import { render, staticRenderFns } from "./UiIconCard.vue?vue&type=template&id=69fcba09&"
import script from "./UiIconCard.vue?vue&type=script&lang=js&"
export * from "./UiIconCard.vue?vue&type=script&lang=js&"
import style0 from "./UiIconCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports